"use client";

import * as React from "react";
import { MarketingTrackedLink } from "@/components/site/primitives/marketing-tracked-link";
import { getTrialSignupHref, type PaidPlan } from "@/lib/content/pricing";

type PricingSignupLinkProps = {
  billingCycle: "monthly" | "yearly";
  className?: string;
  planCode: PaidPlan["planCode"];
  children: React.ReactNode;
};

export function PricingSignupLink({
  billingCycle,
  children,
  className,
  planCode,
}: PricingSignupLinkProps) {
  const href = React.useMemo(
    () => getTrialSignupHref(planCode, billingCycle, "pricing_trial"),
    [billingCycle, planCode],
  );

  return (
    <MarketingTrackedLink
      href={href}
      className={className}
      eventName="pricing_cta_clicked"
      eventProperties={{
        app_area: "pricing",
        billing_cycle: billingCycle,
        cta_id: "pricing_trial",
        plan_code: planCode,
        route_name: "home.pricing",
        marketing_id_transport: "parent_domain_cookie",
      }}
    >
      {children}
    </MarketingTrackedLink>
  );
}
